import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  onClick?: () => void;
  text?: string;
  className?: string;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  onClick,
  text = 'Book Your Sales OS Audit Call',
  className = ''
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.location.href = 'https://form.typeform.com/to/w7LMrDGe';
    }
  };
  return <div className={`flex justify-center ${className}`} data-id="element-56">
      <motion.button onClick={handleClick} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} className="inline-flex items-center gap-2 py-3 px-6 sm:py-4 sm:px-8 text-[#F5F5F7] font-bold rounded-lg text-sm sm:text-lg md:text-xl bg-gradient-to-r from-[#6366F1] to-[#7C3AED] hover:shadow-[0_0_40px_rgba(124,58,237,0.6)] transition-all duration-300 shadow-xl whitespace-nowrap" data-id="element-57">
        {text}
        <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-58" />
      </motion.button>
    </div>;
};